<template>
  <div class="discoverys">
    <div id="containerDis" class="clearfix discovery">
      <ul class="col" style="padding-right: 5px">
      </ul>
      <ul class="col" style="padding-right: 5px">
      </ul>
    </div>
    <div class="content index-content" style="padding-top: 0;margin-bottom: 54px;text-align: center;font-size: 16px;color: #888">
      <div class="id-content-inner"  v-if="busyDis">
        <div class="loader">
          <div class="loader-inner ball-pulse" style="display: block">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
      <div v-else style="padding: 10px 0; text-align: center;font-size: 14px;">到底了</div>
    </div>
    <!-- nav-bottom -->
    <div class="nav-bottom" style="z-index: 8">
      <router-link class="icon-title" to="/home">
        <i class="icon-index"></i>
        发现
      </router-link>
      <!--router-link class="nav-on" to="/discovery">
        <i class="icon-find"></i>
        发现
      </router-link-->
      <router-link class="icon-title" to="/MyMessage">
      <i class="icon-mine"></i>
      我的
      </router-link>
    </div>
  </div>

</template>

<script>
  export default {
    data (){
    return {
      fileItem: null,
      tops: '0',
      data: '',
      one: true,
      page: 1,
      scroll: true,
      busyDis: true,
    }
  },
  methods: {
    //操作按钮事件
    getMinUl() { //每次获取最短的ul,将图片放到其后
      var arrUl = $("#containerDis .col");
      var minUl = arrUl.eq(0);
      arrUl.each(function (index, elem) {
        if ($(elem).height() < minUl.height()) {
          minUl = $(elem);
        }
      });
      return minUl;
    },
    loadMeinv() {
      var that = this;
      // var data = 0;
      that.$http.get(API.FileList, {params: {page: that.page,pagesize: 15,version: 2,is_recommend: 1}})
        .then(function (res) {
          console.log(res);
          if(res.code == 0){
            var data = res.data;
            var pageSize = 0;
            for (var i = 0; i < data.length; i++) {//每次加载时模拟随机加载图片
              if(res.data[i].file  && res.data[i].file != false){
                pageSize = ++pageSize;
                var html = "";
                var img = '',type= '';
                if(data[i].file_type == 'image'){
                  img = data[i].file.image_url;
                  type = '<em class="em-img">图片</em>';
                }else{
                  img = data[i].file.thumb_url;
                  type = '<em class="em-video">'+that.formatSeconds(data[i].file.time_span)+'</em>';
                }
                //预览图尺寸
                img += '?p=3&o=2&w=350&h=197';
                html +="<li>"+
                        "<div class='WaterfallItem-div'>"+
                        "<div class='Waterfall-Location' water='"+ JSON.stringify(res.data[i]) +"' >"+
                        "<img  class='Waterfall' src='"+ img +"' alt=''/>"+type+""+
                        "</div>"+
                        "<div class='WaterfallItem-tit'>"+data[i].file.title+"</div>"+
                        "<p class='WaterfallItem-p'>"+
                        "<img  src='"+data[i].user.face_url+"' alt=''/>"+ data[i].file.nickname +"</p>"+
                        "</div>"+
                      "</li>";
                var minUl = that.getMinUl();
                minUl.append(html);
              }
            }
            that.$nextTick(function () {
              if (res.data.length === 0 || res.data.length  < 10) {
                $('.containerDis').css({'padding-bottom': '44px'});
                that.scroll = false;
                that.busyDis= false
              } else {
                that.scroll = true;
              }
              if(that.one){
                if(res.total == 0){
                    $('.discoverys').find('.index-content').html('未查找到相关作品').css('margin-top','40px')
                }else{
                    $('.discoverys').find('.index-content').css('background','#e3e3e3');
                }

                if($('#containerDis').find('li').length > 0){
                  var img = $('#containerDis').find('li').find('img').attr('src')
                }
                let metas = $('head').children('meta');
                var desc = metas[1].content;
                var dataName = {
                  title: document.title,  //分享标题
                  desc: that.removeTAG(desc,110),//metas[1].content,//分享简介(内容)
                  imgAddress: img,//分享图片地址
                  Retain: '',//保留
                  url: API.UrlName + 'discovery' //点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
                };
                that.weixinShare(dataName);
                that.one = false;
              }
            });
          }
        });
    },
    water(item){
      this.$router.push({name:'VideoName',params: {id:item.activity_id,uuid: item.file_id,type:item.file_type}})
    },
    formatSeconds(value){
      var theTime = parseInt(value);// 秒
      var theTime1 = 0;// 分
      var theTime2 = 0;// 小时
      // alert(theTime);
      if(theTime > 60) {
        theTime1 = parseInt(theTime/60);
        theTime = parseInt(theTime%60);
        // alert(theTime1+'-'+theTime);
        if(theTime1 > 60) {
          theTime2 = parseInt(theTime1/60);
          theTime1 = parseInt(theTime1%60);
        }
      }
      var result = ''+parseInt(theTime);
      //分钟
      if(theTime1 > 0) {
        if(theTime1 >= 10){
          if(result >= 10){
            result = '00:'+parseInt(theTime1)+':'+result;
          }else{
            result = '00:'+parseInt(theTime1)+':0'+result;
          }
        }else{
          if(result >= 10){
            result = '00:0'+parseInt(theTime1)+':'+result;
          }else{
            result = '00:0'+parseInt(theTime1)+':0'+result;
          }
        }
      }else{
        if(result >= 10){
          result = '00:00:'+result;
        }else{
          result = '00:00:'+ '0' + result;
        }
      }
      if(theTime2 > 0) {
        if(theTime2 >= 10){
          result = parseInt(theTime2)+':' + result.substring(2);
        }else{
          result = '0' + parseInt(theTime2) + result.substring(2);
        }
      }else{

      }
      return result;
    }
  },

  created: function () {
    //第一次执行
    this.loadMeinv();
  },
  mounted: function () {
    //操作DOM
    var that = this;
    //console.log(1)
    if (that.IsPC()) {
      window.location.href = API.IsPcName
    }
    $('#containerDis').on('click','li',function(){
      var item = $(this).find('.Waterfall-Location').attr('water');
      that.water(JSON.parse(item))
    });
    $(window).on("scroll", function () {
      var minUl = that.getMinUl();
      if (minUl.height()+100 <= $(window).scrollTop() + $(window).height() && that.scroll == true) {
        that.scroll = false;
        that.page = ++that.page;
        //console.log(that.page);
        //当最短的ul的高度比窗口滚出去的高度+浏览器高度大时加载新图片
        that.loadMeinv();
      }

    })

  }

  }
</script>

<style>
  * {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  a, img {
    border: 0;
  }

  body {
    font: 12px/180% Arial, Helvetica, sans-serif, "新宋体";
  }

  /* container */
  #containerDis {
    width: 100%;
    padding: 5px;
    padding-right: 0px;
  }

  #containerDis ul {
    width: 50%;
    list-style: none;
    float: left;
  }

  #containerDis ul li {
    margin-bottom: 8px;
  }

  .discovery{
    background: #e3e3e3;
  }
  .discovery .ay-header{
    line-height: 20px;
  }
  .discovery .heart-shaped{
    display: none;
    position: fixed;
    top: 22%;
    left: 50%;
    margin-top: -40px;
    margin-left: -40px;
    width: 80px;
    height: 80px;
    z-index: 999;
    transition: all 0.15s;
  }
  .discovery .heart-shaped img{
    height: 100%;
    width: 100%;;
  }
  .discovery .discovery-i{
    float: left;
    width: 20%;
    font-style: normal;
    text-align: center;
    position: relative;
  }
  .discovery .discovery-i:before{
    content: " ";
    position: absolute;
    height: 11px;
    width: 11px;
    border: 2px solid #000;
    top: 3px;
    left: 3px;
    border-right: none;
    border-bottom: none;
    transform:rotate(-45deg);
    -ms-transform:rotate(-45deg); 	/* IE 9 */
    -moz-transform:rotate(-45deg); 	/* Firefox */
    -webkit-transform:rotate(-45deg); /* Safari 和 Chrome */
    -o-transform:rotate(-45deg);
  }
  .discovery .discovery-nav{
    float: left;
    width: 60%;
    text-align: center;
    font-size: 16px;;
  }
  .discovery .home-icon{
    float: right;
    width: 20%;
    background-size: 17px auto;
  }
  .WaterfallItem-div{
    width: 100%;
    height: 100%;
    box-shadow: 0 0 8px rgba(0, 0, 0, .2);
    -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, .2);
    border-radius: 8px;
    overflow: hidden;
    background: #f8f8f8;
  }
  .Waterfall{
    min-height: 50px;
    width: 100%;
    height: auto;
    display: block;
  }
  .WaterfallItem-tit{
    font-size: 14px;
    color: #333;
    line-height: 20px;
    height: 30px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    padding: 5px;
    background: #f8f8f8;
  }
  .WaterfallItem-p{
    margin: 0;
    /*height: 40px;*/
    line-height: 24px;
    font-size: 12px;
    color: #7a7a7a;
    background: #f8f8f8;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    padding: 0 5px 5px;
  }
  .WaterfallItem-p img{
    float: left;
    /*margin-top: 8px;*/
    height: 22px;
    width: 22px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .Waterfall-Location{
    position: relative;
  }
  .Waterfall-Location em{
    font-style: normal;
    position: absolute;
    font-size: 12px;
    background: rgba(0,0,0,.2);
    padding: 1px 8px;
    border-radius: 8px;
    color: #fff;
  }
  .Waterfall-Location .em-img{
    top: 10px;
    right: 10px;
  }
  .Waterfall-Location .em-video{
    bottom: 10px;
    right: 10px;
  }
  .noScroll {
    overflow-y: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/discovery.vue